export const SUBMIT_ADDRESS_SCREEN = 'SUBMIT_ADDRESS_SCREEN';
export const TOGGLE_ADD_ADDRESS = 'TOGGLE_ADD_ADDRESS'; // not sure this is the right place?
export const TOGGLE_EDIT_ADDRESS = 'TOGGLE_EDIT_ADDRESS';
export const UPDATE_ADDRESS = 'UPDATE_ADDRESS';
export const SUBMIT_SHIPPING_SCREEN = 'SUBMIT_SHIPPING_SCREEN';

/* Pure actions
 *
 *  NOTE: All side-effects of an action (async requests, etc) should
 *  be in ../epics/
 */
const submitAddressScreen = () => ({
  type: SUBMIT_ADDRESS_SCREEN,
});
const submitShippingScreen = () => ({
  type: SUBMIT_SHIPPING_SCREEN,
});

const toggleAddAddress = () => ({
  type: TOGGLE_ADD_ADDRESS,
});
const toggleEditAddress = (address) => ({
  type: TOGGLE_EDIT_ADDRESS,
  value: address,
});
const submitUpdateAddress = ({ id, address }) => ({
  type: UPDATE_ADDRESS,
  value: { id, address },
});

export {
  toggleAddAddress,
  toggleEditAddress,
  submitUpdateAddress,
  submitAddressScreen,
  submitShippingScreen,
};
